import { useState, useEffect } from "react";
import api from "../../utils/api";
import { INP, S, THEME, TblRow, TblCell, StatusBadge, tblHead, useIsMobile } from "./AdminComponents";
import { useLanguage } from "../../context/LanguageContext";

const { G, G3, O2 } = THEME;

const INTEREST_AREAS = [
  { ne: "शहरी योजना तथा भौतिक पूर्वाधार",           en: "Urban Planning & Physical Infrastructure" },
  { ne: "सुरक्षा तथा सार्वजनिक सुरक्षा",              en: "Security & Public Safety" },
  { ne: "खानेपानी तथा जल व्यवस्थापन",                en: "Drinking Water & Water Management" },
  { ne: "फोहोर तथा प्रदूषण व्यवस्थापन",               en: "Waste & Pollution Management" },
  { ne: "वन, वातावरण तथा पर्यटन",                    en: "Forest, Environment & Tourism" },
  { ne: "शिक्षा, अनुसन्धान तथा ज्ञान विकास",           en: "Education, Research & Knowledge Development" },
  { ne: "शिल्प, सीप तथा उद्यमशीलता विकास",            en: "Craft, Skill & Entrepreneurship Development" },
  { ne: "स्वास्थ्य तथा जनस्वास्थ्य",                  en: "Health & Public Health" },
  { ne: "स्वस्थ जीवनशैली तथा उपभोक्ता हित संरक्षण",     en: "Healthy Lifestyle & Consumer Rights Protection" },
  { ne: "खेलकुद तथा खेल प्रशिक्षण",                   en: "Sports & Sports Training" },
  { ne: "सूचना प्रविधि तथा स्मार्ट सिटी विकास",         en: "IT & Smart City Development" },
  { ne: "मिडिया तथा सञ्चार",                        en: "Media & Communication" },
  { ne: "व्यापार, उद्योग तथा आर्थिक विकास",           en: "Trade, Industry & Economic Development" },
  { ne: "कृषि तथा सहकारी विकास",                     en: "Agriculture & Cooperative Development" },
  { ne: "विपद् व्यवस्थापन तथा जलवायु अनुकूलन",         en: "Disaster Management & Climate Adaptation" },
  { ne: "कला, संस्कृति तथा पहिचान संरक्षण",            en: "Art, Culture & Identity Preservation" },
  { ne: "सुशासन, आर्थिक नीति तथा वित्तीय व्यवस्थापन",   en: "Good Governance, Economic Policy & Financial Management" },
  { ne: "सामाजिक सुरक्षा तथा समावेशी विकास",           en: "Social Security & Inclusive Development" },
  { ne: "महिला, बालबालिका तथा युवा विकास",            en: "Women, Children & Youth Development" },
  { ne: "अन्तर्राष्ट्रिय सम्बन्ध तथा साझेदारी",         en: "International Relations & Partnership" },
  { ne: "प्रशासन तथा संस्थागत व्यवस्थापन",             en: "Administration & Institutional Management" },
];

const AREA_EN_BY_NE = Object.fromEntries(INTEREST_AREAS.map(a => [a.ne, a.en]));

const CONTENT = {
  ne: {
    statTotal:         "कुल",
    statPending:       "विचाराधीन",
    statApproved:      "स्वीकृत",
    statRejected:      "अस्वीकृत",
    deltaSoFar:        "अहिलेसम्म",
    deltaPending:      "प्रतीक्षामा",
    deltaActive:       "सक्रिय",
    deltaRejected:     "अस्वीकार",
    searchPlaceholder: "🔍 नाम, इमेल, फोनद्वारा खोज्नुहोस्…",
    filterAllStatus:   "सबै स्थिति",
    statusPending:     "विचाराधीन",
    statusApproved:    "स्वीकृत",
    statusRejected:    "अस्वीकृत",
    filterAllAreas:    "सबै रुचि क्षेत्र",
    refresh:           "↻ ताजा गर्नुहोस्",
    colName:           "नाम",
    colEmail:          "इमेल",
    colPhone:          "फोन",
    colArea:           "रुचि क्षेत्र",
    colStatus:         "स्थिति",
    colAction:         "कार्य",
    loading:           "स्वयंसेवकहरू लोड हुँदैछ…",
    empty:             "कुनै स्वयंसेवक भेटिएन।",
    errLoad:           "स्वयंसेवकहरू लोड गर्न असफल भयो।",
    errStatus:         "स्थिति अपडेट गर्न असफल भयो।",
    errReject:         "अस्वीकृत गर्न असफल भयो।",
    confirmReject:     "के तपाईं यो निवेदन अस्वीकृत गर्न (स्थायी रूपमा मेटाउन) निश्चित हुनुहुन्छ?",
    approveBtn:        "✓ स्वीकृत",
    rejectBtn:         "✕ अस्वीकृत",
    saving:            "…",
  },
  en: {
    statTotal:         "Total",
    statPending:       "Pending",
    statApproved:      "Approved",
    statRejected:      "Rejected",
    deltaSoFar:        "So far",
    deltaPending:      "Awaiting",
    deltaActive:       "Active",
    deltaRejected:     "Rejected",
    searchPlaceholder: "🔍 Search by name, email, phone…",
    filterAllStatus:   "All Statuses",
    statusPending:     "Pending",
    statusApproved:    "Approved",
    statusRejected:    "Rejected",
    filterAllAreas:    "All Interest Areas",
    refresh:           "↻ Refresh",
    colName:           "Name",
    colEmail:          "Email",
    colPhone:          "Phone",
    colArea:           "Interest Area",
    colStatus:         "Status",
    colAction:         "Action",
    loading:           "Loading volunteers…",
    empty:             "No volunteers found.",
    errLoad:           "Failed to load volunteers.",
    errStatus:         "Failed to update status.",
    errReject:         "Failed to reject.",
    confirmReject:     "Are you sure you want to reject (permanently delete) this application?",
    approveBtn:        "✓ Approve",
    rejectBtn:         "✕ Reject",
    saving:            "…",
  },
};

function VolunteersPage() {
  const { language } = useLanguage();
  const t = CONTENT[language] || CONTENT.en;
  const isMobile = useIsMobile();

  const [volunteers, setVolunteers]     = useState([]);
  const [loading, setLoading]           = useState(true);
  const [error, setError]               = useState("");
  const [search, setSearch]             = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterArea, setFilterArea]     = useState("all");
  const [saving, setSaving]             = useState(null);

  useEffect(() => { fetchVolunteers(); }, []);

  async function fetchVolunteers() {
    setLoading(true); setError("");
    try {
      const res  = await api.get("/volunteers");
      const data = Array.isArray(res.data) ? res.data : (res.data?.data ?? []);
      const active   = data.filter(x => x.status !== "rejected");
      const rejected = data.filter(x => x.status === "rejected");
      setVolunteers(active);
      rejected.forEach(x => { api.delete(`/volunteers/${x._id}`).catch(() => {}); });
    } catch (e) {
      setError(e.response?.data?.message || t.errLoad);
    } finally {
      setLoading(false);
    }
  }

  async function updateStatus(id, status) {
    setSaving(id);
    try {
        const res     = await api.put(`/volunteers/${id}`, { status });
        const updated = res.data?.data ?? res.data;
        setVolunteers(v => v.map(x => x._id === id ? { ...x, status: updated.status } : x));
    } catch (e) {
        alert(e.response?.data?.message || t.errStatus);
    } finally {
        setSaving(null);
    }
}

  async function handleReject(id) {
    if (!window.confirm(t.confirmReject)) return;
    setSaving(id);
    try {
      await api.delete(`/volunteers/${id}`);
      setVolunteers(v => v.filter(x => x._id !== id));
    } catch (e) {
      alert(e.response?.data?.message || t.errReject);
    } finally {
      setSaving(null);
    }
  }

  function areaLabel(neText) {
    if (!neText) return neText;
    return language === "en" ? (AREA_EN_BY_NE[neText] || neText) : neText;
  }

  const areas = ["all", ...Array.from(new Set(volunteers.map(v => v.interestArea).filter(Boolean)))];

  const filtered = volunteers.filter(v => {
    const q = search.toLowerCase();
    const matchSearch = v.name?.toLowerCase().includes(q) || v.email?.toLowerCase().includes(q) || v.phone?.includes(q);
    const matchStatus = filterStatus === "all" || v.status === filterStatus;
    const matchArea   = filterArea   === "all" || v.interestArea === filterArea;
    return matchSearch && matchStatus && matchArea;
  });

  const stats = [
    { label: t.statTotal,    value: volunteers.length,                                      icon: "🤝", delta: t.deltaSoFar    },
    { label: t.statPending,  value: volunteers.filter(v => v.status === "pending").length,  icon: "⏳", delta: t.deltaPending  },
    { label: t.statApproved, value: volunteers.filter(v => v.status === "approved" || v.status === "accepted").length, icon: "✅", delta: t.deltaActive },
    { label: t.statRejected, value: volunteers.filter(v => v.status === "rejected").length, icon: "❌", delta: t.deltaRejected },
  ];

  const VOL_COLS = "1.2fr 1.6fr 1fr 1.2fr 110px 210px";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {/* Stat cards: 4 on desktop, 2 on mobile */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(4, 1fr)", gap: 10 }}>
        {stats.map(s => (
          <div key={s.label} style={S.statCard}>
            <div style={S.statIcon}>{s.icon}</div>
            <div>
              <div style={S.statVal}>{s.value}</div>
              <div style={S.statLabel}>{s.label}</div>
              <div style={S.statDelta}>{s.delta}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ ...S.card, padding: "12px 16px" }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <input placeholder={t.searchPlaceholder} value={search} onChange={e => setSearch(e.target.value)} style={{ ...INP, flex: "1 1 200px", width: "auto", minWidth: 0, maxWidth: isMobile ? "100%" : 260 }} />
          <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={{ ...INP, width: "auto", minWidth: 120 }}>
            <option value="all">{t.filterAllStatus}</option>
            <option value="pending">{t.statusPending}</option>
            <option value="approved">{t.statusApproved}</option>
            <option value="rejected">{t.statusRejected}</option>
          </select>
          <select value={filterArea} onChange={e => setFilterArea(e.target.value)} style={{ ...INP, flex: "1 1 200px", width: "auto", minWidth: 0, maxWidth: isMobile ? "100%" : 260 }}>
            <option value="all">{t.filterAllAreas}</option>
            {areas.filter(a => a !== "all").map(a => <option key={a} value={a}>{areaLabel(a)}</option>)}
          </select>
          <button onClick={fetchVolunteers} style={{ marginLeft: isMobile ? 0 : "auto", padding: "7px 14px", borderRadius: 7, background: G3, border: `1px solid ${G}`, color: G, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>{t.refresh}</button>
        </div>
      </div>

      {error && <div style={{ background: "rgba(239,68,68,0.08)", border: "1px solid #fca5a5", borderRadius: 8, padding: "10px 16px", color: "#ef4444", fontSize: 13 }}>⚠ {error}</div>}

      <div style={{ ...S.tableWrap, ...S.tableScroll }}>
        <div style={{ minWidth: isMobile ? 780 : undefined }}>
          <div style={tblHead(VOL_COLS, isMobile)}>
            <span>{t.colName}</span><span>{t.colEmail}</span><span>{t.colPhone}</span><span>{t.colArea}</span><span>{t.colStatus}</span><span>{t.colAction}</span>
          </div>
          {loading && <div style={{ padding: "30px", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>{t.loading}</div>}
          {!loading && filtered.length === 0 && <div style={{ padding: "30px", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>{t.empty}</div>}
          {!loading && filtered.map((v, i) => (
            <TblRow key={v._id} cols={VOL_COLS} isLast={i === filtered.length - 1}>
              <TblCell><span style={{ fontWeight: 600, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{v.name}</span></TblCell>
              <TblCell><span style={{ color: "#6b7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: 12 }}>{v.email}</span></TblCell>
              <TblCell><span style={{ color: "#6b7280", whiteSpace: "nowrap" }}>{v.phone}</span></TblCell>
              <TblCell><span style={{ color: "#374151", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{areaLabel(v.interestArea)}</span></TblCell>
              <TblCell fit><StatusBadge status={v.status} language={language} /></TblCell>
              <TblCell fit>
                <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
                  {v.status !== "approved" && v.status !== "accepted" && (
                    <button disabled={saving === v._id} onClick={() => updateStatus(v._id, "approved")}
                      style={{ background: G3, border: `1px solid ${G}`, color: G, borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontWeight: 600, opacity: saving === v._id ? 0.6 : 1, whiteSpace: "nowrap" }}>
                      {saving === v._id ? t.saving : t.approveBtn}
                    </button>
                  )}
                  {v.status !== "rejected" && (
                    <button disabled={saving === v._id} onClick={() => handleReject(v._id)}
                      style={{ background: "rgba(239,68,68,0.08)", border: "1px solid #fca5a5", color: "#ef4444", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontWeight: 600, opacity: saving === v._id ? 0.6 : 1, whiteSpace: "nowrap" }}>
                      {saving === v._id ? t.saving : t.rejectBtn}
                    </button>
                  )}
                </div>
              </TblCell>
            </TblRow>
          ))}
        </div>
      </div>
    </div>
  );
}

export default VolunteersPage;
